import * as React from "react";
import {assets} from "../../helpers";

declare const require: any;
const $: any = require('jquery');
window['$'] = $;
window['jQuery'] = $;
require('../../../resources/assets/fancybox/jquery.fancybox.pack');

$(function () {
    $.fancybox.defaults.nextClick = true;
    $.fancybox.defaults.helpers.overlay = {nextClick: true, closeClick: false};
});

$(window).load(function () {
    var images = {};
    
    $.getJSON('/assets/images.json?3', function (data) {
        for (var key in data) {
            if (data.hasOwnProperty(key)) {
                images[key] = [];
                data[key].forEach(function (row) {
                    images[key].push({href: '/images/' + key + '/' + row.replace('{size}', 'big')});
                });
            }
        }
        
        $(document.body).on('click', 'section.images ul li', function (e) {
            var item = $(this), id = item.data('galleryId');
            e.preventDefault();
            if (id && images[id].length > 0) {
                $.fancybox.open(images[id], {index: $(this).data('index') - 1});
            }
        });
    });
});


export class GalleryConference extends React.Component<any, any> {
    render() {
        return (
            <section className="images">
                <a name="images" />
                <ul>
                    <li data-gallery-id="2012">
                        <h4>LOUDHEAD 2012</h4>
                        <a href="#"><img src="/images/2012/small/1.jpg" className="img-responsive" /></a>
                    </li>
                    <li data-gallery-id="2014">
                        <h4>LOUDHEAD 2014</h4>
                        <a href="#"><img src="/images/2014/small/6.jpg" className="img-responsive" /></a>
                    </li>
                    <li data-gallery-id="2016">
                        <h4>LOUDHEAD 2016</h4>
                        <a href="#"><img src="/images/2016/small/11.jpg" className="img-responsive" /></a>
                    </li>
                </ul>
            </section>
        )
    }
}



/** WEBPACK FOOTER **
 ** ./src/route/Main/GalleryConference.tsx
 **/